import React from 'react'

interface OverclaimViewHeaderDescriptionProps {
    amendingShares?: boolean
}

const OverclaimViewHeaderDescription = (props: OverclaimViewHeaderDescriptionProps) => {
    const { amendingShares } = props
    return (
        <>
            {!amendingShares ? (
                <p>
                    The Overclaims Tool enables Members to see works they have registered that are in overclaim.
                    Overclaims occur when the total shares submitted by Members for a work add up to more than 100%.
                    Members can also use the Overclaims Tool to send an email to all Members claiming shares of a work
                    so that all claimants can work together to resolve the overclaim.
                </p>
            ) : (
                <p>
                    {`To amend your shares on the work, edit the percentage in the 
                        "Collection Share" field below for the appropriate name, 
                        then click the "Submit" button at the bottom of the page.`}
                </p>
            )}
            <p>
                Click{' '}
                <a
                    target="_blank"
                    href="https://help.themlc.com/en/support/what-is-an-overclaim-and-how-do-i-resolve-one-using-the-overclaims-tool"
                    rel="noreferrer"
                >
                    here
                </a>{' '}
                for our Help Center article detailing options to resolve an overclaim.
            </p>
        </>
    )
}
export default OverclaimViewHeaderDescription
